"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Link from "./webflow_modules/Basic/components/Link";
import List from "./webflow_modules/Basic/components/List";
import { AdvSearchAmenitiesCheckboxItem } from "./AdvSearchAmenitiesCheckboxItem";

export function AdvSearchAmenitiesDropdown2({
  buttonProps = {},
  buttonText = "Amenities",
  children = "",
  showButton = true,
  showInline = true,
  showPopover = true,
}) {
  return (
    <Block className={"div-block-85"} tag={"div"}>
      <Block className={" adv-search-lable"} tag={"div"}>
        {"Amenities"}
      </Block>
      <Block className={"search-thin-component-2-copy"} tag={"div"}>
        <Block className={"amenities-container"} tag={"div"}>
          {showButton ? (
            <Link
              button={true}
              className={"button-11"}
              options={{
                href: "#",
              }}
              {...buttonProps}
            >
              {buttonText}
            </Link>
          ) : null}
          {showInline ? (
            <Block className={"amenities-inline-container"} tag={"div"}>
              <List
                className={"amenities-list-inline"}
                tag={"ul"}
                unstyled={false}
              >
                {children ?? (
                  <>
                    <AdvSearchAmenitiesCheckboxItem
                      showDisabled={false}
                      text={"Onsite Pet Friendly Dog Parks"}
                    />
                    <AdvSearchAmenitiesCheckboxItem showDisabled={false} />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                  </>
                )}
              </List>
            </Block>
          ) : null}
          {showPopover ? (
            <Block className={"amenities-popover-container"} tag={"div"}>
              <List className={"amenities-list"} tag={"ul"} unstyled={false}>
                {children ?? (
                  <>
                    <AdvSearchAmenitiesCheckboxItem
                      showDisabled={false}
                      text={"Onsite Pet Friendly Dog Parks"}
                    />
                    <AdvSearchAmenitiesCheckboxItem showDisabled={false} />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                    <AdvSearchAmenitiesCheckboxItem />
                  </>
                )}
              </List>
            </Block>
          ) : null}
        </Block>
      </Block>
    </Block>
  );
}
